import React from 'react';

import { LoginRecuperacaoSenhaPageComp } from 'pages/login-recuperacao-senha/components';

export function LoginRecuperacaoSenhaPage(): JSX.Element {
    return <LoginRecuperacaoSenhaPageComp />;
}
